import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { IOvertimeType } from '../models/overtime-type.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class OvertimeTypeApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/OvertimeTypes`;
  }

  constructor(private http: HttpClient) {}

  loadOvertimeTypes(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IOvertimeType[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IOvertimeType[]>>(this.url, { params });
  }

  loadAllOvertimeTypes(): Observable<IOvertimeType[]> {
    const url = `${this.url}/All`;

    let params = new HttpParams();
    params = params.set('DepartmentId', getDepartmentId());

    return this.http.get<IOvertimeType[]>(url, { params });
  }

  loadOvertimeTypeById(id: string): Observable<IOvertimeType> {
    const url = `${this.url}/${id}`;
    return this.http.get<IOvertimeType>(url);
  }

  createOvertimeType(overtimeType: IOvertimeType): Observable<IOvertimeType> {
    return this.http.post<IOvertimeType>(this.url, overtimeType, { headers });
  }

  updateOvertimeType(overtimeType: IOvertimeType): Observable<IOvertimeType> {
    const url = `${this.url}/${overtimeType.id}`;
    return this.http.put<IOvertimeType>(url, overtimeType, { headers });
  }

  deleteOvertimeType(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
